import React from 'react';
import PropTypes from 'prop-types';
import { mapObject, constant } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getActionListStyles } from '../styles';
import { StyledObjectiveItem } from './objective-item';

const ActionList = ({
  classes,
  title,
  actionItems,
}) => {
  const ariaLabelId = `campaignCreationActionListTitle-${Math.floor(Math.random() * 10000)}`;

  return (
    <div className={`${classes.actionList} action-list`}>
      {title && (
        <h5 className={`${classes.title} action-list-title`} id={ariaLabelId}>
          {title}
        </h5>
      )}
      <div className="action-list-group" role="radiogroup" aria-labelledby={ariaLabelId}>
        {actionItems.map((item, index) => (
          <StyledObjectiveItem
            className={`action-item-${item.id}`}
            key={item.id}
            ariaItemSize={actionItems.length}
            ariaItemIndex={index + 1}
            {...item}
          />
        ))}
      </div>
    </div>
  );
};

ActionList.propTypes = {
  classes: PropTypes.shape(mapObject(
    getActionListStyles({}, {}),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  title: PropTypes.string,
  actionItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    descriptionLine: PropTypes.string.isRequired,
    helpId: PropTypes.string,
    onClick: PropTypes.func,
    'aria-label': PropTypes.string,
    isSelected: PropTypes.bool,
  })).isRequired,
};

ActionList.defaultProps = {
  title: null,
};

export const StyledActionList = withDefaultStyles(ActionList, getActionListStyles);
